import { render } from "./AbtestDemograResultPage.vue?vue&type=template&id=56de901b"
import script from "./AbtestDemograResultPage.vue?vue&type=script&lang=js"
export * from "./AbtestDemograResultPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__